export default "__VITE_ASSET__4d3bfcbf__"